export default class TaxRate {
  id;
  nonce;

  constructor() {
    this.nonce = Math.random().toString(36).substring(7);
  }
}
